import { loadStripe } from '@stripe/stripe-js'

let stripePromise = null

export const getStripe = () => {
  if (!stripePromise) {
    const publishableKey = "pk_live_51SKMM2J3N6QMImyOfhYbKII0b5P6ChNIxAiDhAm4sxh5NK4KUXLGifnGzeEnLvAnHVzy26BJekqlIIZH6kVUQ6sl00sAIxHtwx"
    if (!publishableKey) {
      throw new Error('Stripe publishable key is not configured')
    }
    stripePromise = loadStripe(publishableKey)
  }
  return stripePromise
}

export const resetStripe = () => {
  stripePromise = null
}
